import { Component, OnChanges, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map } from 'rxjs';
import { FcpTreeItem } from '../../domain/models/fcpTreeItem.model';
import { toggleActiveTestGroupItem } from '../../domain/reducers/fcp.actions';
import { selectActiveTestGroupItem } from '../../domain/reducers/fcp.reducer';
import { FcpTreeElement } from './fcpTreeElement.directive';

@UntilDestroy()
@Component({
    selector: 'app-fcp-test-group-item',
    templateUrl: 'fcpTestGroupItem.component.html',
    styleUrls: ['fcpTestGroupItem.component.scss'],
})
export class FcpTestGroupItemComponent extends FcpTreeElement implements OnInit, OnChanges {
    ngOnInit() {
        this.active$ = this.store.select(selectActiveTestGroupItem).pipe(
            map((storeItem: FcpTreeItem) => {
                if (storeItem && storeItem.name === this.item.name) {
                    return true;
                } else {
                    return false;
                }
            }),
            untilDestroyed(this),
        );
    }

    toggleExpand() {
        this.store.dispatch(toggleActiveTestGroupItem({ payload: this.item }));
    }
}
